export default {
  THROW_PILLOW: 9,
  ACCENT_TABLES: 28,
  NIGHTSTANDS: 33,
  INDOOR_RUGS: 30,
  LIGHTING: 32,
  OUTDOOR_RUGS: 31,
  BEDDING: 50
};
